import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/ndyl-mini-3x.png'


const _withScopeId = n => (_pushScopeId("data-v-233c6dcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-sider" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "logo-title" }
const _hoisted_5 = { class: "layout-main-menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1))

import { state as globalState, service as globalService } from '@/modules/global';
import { computed, reactive, nextTick } from 'vue';
import { usePermissionStore } from '@/modules/permission';
import SubMenu from '@/components/common/SubMenu.vue';
import { state as pageTabState } from '@/modules/page-tab';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutSider',
  setup(__props) {

const preStore = usePermissionStore();

const state = reactive({
  openKeys: ['/home'],
});

const siderMenu = computed(() => {
  return preStore.sidebarRouters.filter(item => item.meta?.title);
});

/** 存在前端代码中的固定路由需要管理固定的父目录 id 目前只考虑单个固定页面 不包含层级关系 */
const manageRouteId = {
  '/home': -1,
};

/** 使得目录图标高亮显示函数 */
const heighLightIcon = () => {
  /** 遍历目录层级的时候 找到对应的顶部父目录 id */
  const judge = (arr, id) => {
    arr.forEach(item => {
      if (item.path === pageTabState.activePage) {
        globalState.topFatherId = id;
      }
      if (item.children) {
        judge(item.children, id);
      }
    });
  };
  /** 若是打开目录那么需要遍历寻找并更新父目录 id，使之高亮显示 */
  if (state.openKeys.length) {
    nextTick(() => {
      siderMenu.value.forEach(item => {
        if (item.children) {
          judge(item.children, item.id);
        }
      });
    });
  }
  /** 管理前端 router 里面写死的路由 比如 '/home'，也需要高亮 */
  if (manageRouteId[pageTabState.activePage] !== undefined) {
    globalState.topFatherId = manageRouteId[pageTabState.activePage];
  }
  /** 没有层级关系 就单个页面，比如现有的凝动官网，图标高亮显示 */
  siderMenu.value.forEach(item => {
    if (item.fullPath === pageTabState.activePage) {
      globalState.topFatherId = item.id;
    }
  });
};

const getSelectedKeys = computed(() => {
  heighLightIcon();
  return [pageTabState.activePage];
});

const onOpenChange = (openKeys: string[]) => {
  const latestOpenKey = openKeys.find(key => state.openKeys.indexOf(key) === -1);
  if (!siderMenu.value.some(i => i.path === latestOpenKey)) {
    state.openKeys = openKeys;
  } else {
    state.openKeys = latestOpenKey ? [latestOpenKey] : [];
  }
};

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("div", _hoisted_4, "脑效能临床信息平台", 512), [
        [_vShow, !_unref(globalState).collapsed]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_menu, {
        "open-keys": state.openKeys,
        mode: "inline",
        "selected-keys": _unref(getSelectedKeys),
        style: { height: '100%', borderRight: 0 },
        onOpenChange: onOpenChange,
        onSelect: _cache[0] || (_cache[0] = ($event: any) => (_unref(globalService).turnPage($event.key)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, { key: "/home" }, {
            icon: _withCtx(() => [
              _createVNode(_component_SvgIcon, {
                size: "14px",
                icon: 'newHome',
                "open-key": manageRouteId['/home']
              }, null, 8, ["open-key"])
            ]),
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(siderMenu), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item?.meta?.link || item.fullPath || item.id
            }, [
              (!item?.children?.length)
                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item?.meta?.link || item.fullPath
                  }, {
                    icon: _withCtx(() => [
                      (item.meta?.icon)
                        ? (_openBlock(), _createBlock(_component_SvgIcon, {
                            key: 0,
                            size: "14px",
                            icon: item.meta?.icon,
                            "open-key": item.id
                          }, null, 8, ["icon", "open-key"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(item.meta?.title), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(SubMenu, {
                    key: item.fullPath,
                    "menu-info": item
                  }, null, 8, ["menu-info"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["open-keys", "selected-keys"])
    ])
  ]))
}
}

})